export default {
    SET_TRANSACTIONS(state,transactions){  state.transactions = transactions; },
   
    SET_META_DATA(state, payload) {
        state.meta = payload;
      },
}